import { KeyValue } from "@/main/models/common";
import { SupplierTypes, SupplierActionTypes } from "./supplierTypes";
import { SupplierFilterRequest } from "@/main/models/request/supplierRequest";

export function getSuppliers(request: SupplierFilterRequest): SupplierActionTypes {
	return {
		type: SupplierTypes.GET_SUPPLIERS,
		payload: { request },
	};
}

export function saveSuppliers(
	data: KeyValue[] | null,
	isError: boolean,
	errorMessages: string[] | null,
): SupplierActionTypes {
	return {
		type: SupplierTypes.SAVE_SUPPLIERS,
		payload: { data, isError, errorMessages },
	};
}

export function resetReducerSuppliers(): SupplierActionTypes {
	return {
		type: SupplierTypes.RESET_REDUCER_SUPPLIERS,
	};
}
